<template lang="pug">
.root
  slot  
</template>

<style lang="scss" scoped>
.root {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>


<script lang="ts">
import fullscreen, { Handle as FullscreenHandle } from 'fullscreen';
import Vue, { CreateElement, VNode } from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component
export default class FullscreenComponent extends Vue {
  private fs!: FullscreenHandle

  @Prop({ default: false })
  fullscreen!: boolean
  @Watch('fullscreen')
  private onFullscreenChane() {
    if (this.fullscreen) {
      this.fs.request()
    } else {
      this.fs.release()
    }
  }

  mounted() {
    this.fs = fullscreen(this.$el as HTMLElement)
    this.fs.on('release', () => this.$emit('update:fullscreen', false))
  }

  beforeDestroy() {
    this.fs.dispose()
  }

  render(h: CreateElement): VNode {
    return h('div', this.$slots.default)
  }
}
</script>